// Translate import
import { useTranslation } from 'react-i18next'
import { TYPES_MENU_LIST } from '../constants/menu'

function PoliticaPrivacidad() {
  const { t } = useTranslation()

  return (
    <div id={TYPES_MENU_LIST.PRIVACY_POLICY}>
      <h2>{t('Política de privacidad Editorial Vicens Vives, S.A.')}</h2>
      <p>
        {t(
          'VICENS VIVES respeta la legislación vigente en materia de protección de datos personales, la privacidad de los usuarios y el secreto y seguridad de los datos de conformidad con lo establecido en la legislación aplicable en materia de protección de datos, y aplica las medidas técnicas y organizativas apropiadas a fin de garantizar y poder demostrar que el tratamiento de datos de los que VICENS VIVES es responsable cumple con la referida normativa.'
        )}
      </p>
      <p>
        {t(
          'Los datos personales sólo serán obtenidos por VICENS VIVES para su tratamiento, cuando sean adecuados, pertinentes y no excesivos en relación con el ámbito y las finalidades determinadas, explícitas y legítimas para las que se hayan obtenido. El Usuario manifiesta que los datos facilitados son ciertos y correctos, y se compromete a comunicar a VICENS VIVES los cambios que se produzcan en los mismos.'
        )}
      </p>
      <p>
        {t(
          'Por ello, VICENS VIVES informa a los usuarios de los principales extremos sobre su política de privacidad y acceso a los datos personales'
        )}
        :
      </p>
      <h3>
        {t('1. Responsable del tratamiento de datos de carácter personal')}
      </h3>
      <p>
        {t(
          'De acuerdo con lo que establece el Reglamento Europeo 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016, el Responsable del tratamiento de datos de carácter personal es EDITORIAL VICENS VIVES, S.A. (VICENS VIVES), con domicilio en Vía Augusta, 260, Local B, 08017 de Barcelona'
        )}{' '}
        ({t('email de contacto')}:{' '}
        <a href='mailto:legal@vicensvives.com'>legal@vicensvives.com</a>).
      </p>
      <h3>{t('2. Obtención de los datos de carácter personal')}</h3>
      <p>
        {t(
          'Los datos de carácter personal tratados por VICENS VIVES han sido obtenidos a través de los siguientes procesos y/o canales'
        )}
        :
      </p>
      <ul>
        <li>
          {t('Formularios de inscripción a los servicios web de VICENS VIVES.')}
        </li>
        <li>
          {t('Formularios de contacto de los portales web de VICENS VIVES.')}
        </li>
        <li>
          {t('Formularios de suscripción a las')} <i>Newsletters</i>{' '}
          {t('de VICENS VIVES.')}
        </li>
        <li>
          {t(
            'Formularios para la participación en concursos y sorteos organizados por VICENS VIVES.'
          )}
        </li>
        <li>
          {t(
            'Formularios para la solicitud de muestras o servicios VICENS VIVES.'
          )}
        </li>
        <li>
          {t(
            'Formularios de recogida de datos de portales de venta de VICENS VIVES.'
          )}
        </li>
      </ul>
      <h3>
        {t('3. Finalidad del tratamiento de los datos de carácter personal')}
      </h3>
      <p>
        {t(
          'VICENS VIVES trata los datos de carácter personal de los usuarios con el fin de poder prestar de manera óptima SERVICIOS VICENS VIVES. De este modo, los datos recabados de los usuarios se utilizan con distintas finalidades, en función de las peticiones de servicios de los usuarios, del interés legítimo de VICENS VIVES, y las autorizaciones y consentimientos expresos de los mismos.'
        )}
      </p>
      <p>
        {t(
          'Las finalidades para el tratamiento de los datos de los SERVICIOS VICENS VIVES son'
        )}
        :
      </p>
      <ul>
        <li>{t('Atender peticiones de servicios presentes y futuras.')}</li>
        <li>
          {t(
            'Atender y gestionar sus peticiones de compra de productos de VICENS VIVES y mantener la relación comercial con los clientes de VICENS VIVES.'
          )}
        </li>
        <li>
          {t(
            'Gestionar de incidencias con los usuarios de los SERVICIOS VICENS VIVES.'
          )}
        </li>
        <li>
          {t(
            'Remitir comunicaciones y notificaciones relacionadas con actualizaciones, mejoras y novedades relativas a los SERVICIOS VICENS VIVES.'
          )}
        </li>
        <li>
          {t(
            'Pedir la opinión a los usuarios de los SERVICIOS VICENS VIVES acerca de los servicios prestados por VICENS VIVES.'
          )}
        </li>
        <li>
          {t(
            'Envío de publicidad de artículos, productos y novedades de VICENS VIVES.'
          )}
        </li>
        <li>
          {t(
            'Envío de newsletters (solamente si el usuario ha realizado la petición u otorgado su consentimiento expreso para ello).'
          )}
        </li>
        <li>
          {t(
            'Cumplimiento de los deberes y obligaciones de naturaleza legal en relación al mantenimiento de datos, así como para poder dar cumplimiento a cualquier requerimiento de información cursado por una autoridad competente. Entre estas obligaciones se incluye la entrega, en determinadas circunstancias, de datos de carácter personal a los citados órganos.'
          )}
        </li>
        <li>
          {t('Tratamiento de')} <i>{t('cookies')}</i>.{' '}
          {t('El tratamiento de datos de carácter personal recabados mediante')}{' '}
          <i>{t('cookies')}</i>{' '}
          {t('solamente se realizará tras la aceptación del sistema de')}{' '}
          <i>{t('cookies')}</i> {t('en la casilla/botón correspondiente')} (
          <a href={`#${TYPES_MENU_LIST.COOKIE_POLICY}`}>
            {t('más información aquí')}
          </a>
          ).
        </li>
      </ul>
      <h3>
        {t(
          '4. Base legal para el tratamiento de los datos de carácter personal'
        )}
      </h3>
      <p>
        {t(
          'La base legal para el tratamiento de datos de los usuarios registrados en determinados SERVICIOS VICENS VIVES cuando estén vinculados con el sector educativo, es el interés legítimo de VICENS VIVES.'
        )}
      </p>
      <p>
        {t(
          'La base legal para el tratamiento de los datos personales para el envío de publicidad y prospección comercial a los usuarios de los SERVICIOS VICENS VIVES es el consentimiento explícito e inequívoco, o el interés legítimo.'
        )}
      </p>
      <p>
        {t(
          'La base legal para el tratamiento de datos personales obtenidos a través de las'
        )}{' '}
        <i>{t('cookies')}</i>{' '}
        {t('es el consentimiento explícito expresado por el usuario.')}
      </p>
      <p>
        {t(
          'Los usuarios manifiestan haber leído y aceptado expresamente la presente Política de Privacidad, al marcar la casilla expresa a tal efecto, habilitada en cada uno de nuestros formularios de contacto, registro y/o acceso a los SERVICIOS VICENS VIVES.'
        )}
      </p>
      <h3>{t('5. Comunicación de datos a terceros')}</h3>
      <p>
        {t(
          'VICENS VIVES no cederá o comunicará a terceros los datos recabados sin previo consentimiento expreso del usuario, excepto en el caso de que la comunicación sea necesaria para prestar el servicio que el usuario haya solicitado o exista una obligación legal para realizar tal comunicación.'
        )}
      </p>
      <p>
        {t(
          'No obstante, lo anterior, VICENS VIVES informa que, para la correcta gestión de algunas de las funciones de los SERVICIOS VICENS VIVES, existen terceras empresas que pueden tener acceso a los datos de carácter personal de los usuarios. Estas terceras empresas están obligadas legalmente a mantener la confidencialidad y secreto de la información, estando sujetas también a una estricta política de privacidad.'
        )}
      </p>
      <h3>
        {t('6. Mantenimiento y conservación de los datos de carácter personal')}
      </h3>
      <p>
        {t(
          'Los datos de carácter personal de los usuarios de los SERVICIOS VV serán conservados durante el tiempo necesario para cumplir la finalidad para la cual se recogieron y, cuando proceda, durante el tiempo en que pueda exigirse algún tipo de responsabilidad derivada de una relación u obligación jurídica o de la ejecución de un contrato, precontrato y/o relación mercantil con los usuarios.'
        )}
      </p>
      <p>
        {t(
          'Cuando un usuario se dé de baja en el sistema, sus datos serán cancelados y conservados en los sistemas de información de VICENS VIVES durante el periodo legal establecido (4 años para la información relativa a las transacciones y relaciones comerciales y 12 meses para el resto de información de los usuarios). Esta información no será accesible ni podrá ser utilizada por ningún usuario y únicamente estará a disposición de los jueces, tribunales y autoridades competentes.'
        )}
      </p>
      <p>
        {t(
          'Si el tratamiento de los datos de los usuarios han sido recogidos para varias finalidades distintas que obligan a su conservación durante plazos distintos, VICENS VIVES aplicará el plazo de conservación más largo.'
        )}
      </p>
      <h3>{t('7. Derechos de los usuarios')}</h3>
      <p>
        {t(
          'Los usuarios de los SERVICIOS VICENS VIVES tienen los derechos de acceso, rectificación, cancelación, oposición, limitación, olvido y portabilidad en materia de protección de datos de carácter personal. Estos derechos suponen que el usuario podrá'
        )}
        :
      </p>
      <ul>
        <li>
          {t(
            'Revocar su consentimiento para el tratamiento de datos para determinadas finalidades, en los casos en los que el tratamiento de sus datos esté condicionado al consentimiento.'
          )}
        </li>
        <li>
          {t(
            'Solicitar más detalles e información sobre el uso que VICENS VIVES hace de sus datos de carácter personal.'
          )}
        </li>
        <li>
          {t(
            'Corregir inexactitudes en la información que VICENS VIVES mantiene.'
          )}
        </li>
        <li>
          {t(
            'Borrar información para cuyo uso VICENS VIVES ya no tiene base jurídica.'
          )}
        </li>
        <li>
          {t(
            'Oponerse a cualquier tratamiento de sus datos que tome como base jurídica el interés legítimo, a menos que los motivos para llevar a cabo ese tratamiento compensen cualquier posible perjuicio hacia sus derechos de protección de datos.'
          )}
        </li>
        <li>
          {t(
            'Restringir y limitar la manera en que VICENS VIVES utiliza sus datos de carácter personal.'
          )}
        </li>
        <li>{t('Solicitar la portabilidad de sus datos personales.')}</li>
      </ul>
      <p>
        {t(
          'Los usuarios podrán realizar cualquier consulta y ejercer cualquiera de sus derechos mediante solicitud dirigida a EDITORIAL VICENS VIVES, S.A. por escrito a la Vía Augusta, 260, Local B, 08017 de Barcelona, llamando al 93 252 37 00 o comunicándolo por escrito a nuestra dirección de correo electrónico'
        )}{' '}
        <a href='mailto:legal@vicensvives.com'>legal@vicensvives.com</a>
      </p>
      <p>
        {t(
          'En caso que los usuarios ejerzan cualquier derecho de los mencionados anteriormente, VICENS VIVES comprobará si el usuario está facultado realmente para ello, ateniendo su petición en los plazos legalmente establecidos por la normativa de protección de datos.'
        )}
      </p>
      <p>
        {t(
          'Si el usuario no está satisfecho o está en desacuerdo con la manera en que VICENS VIVES utiliza sus datos de carácter personal y/o con la respuesta que VICENS VIVES haya podido dar ante el ejercicio de cualquiera de sus derechos, puede presentar una reclamación ante la Agencia Española de Protección de Datos u otros órganos competentes.'
        )}
      </p>
      <h3>{t('8. Registro de usuarios')}</h3>
      <p>
        {t(
          'Para poder registrarse en los SERVICIOS VICENS VIVES es necesario ser mayor de 16 años. Los menores de 16 años no pueden registrarse por sí solos en los SERVICIOS VICENS VIVES. El registro de menores de 16 años requerirá la solicitud de apertura de una cuenta a nombre del menor por parte de su padre o madre, representante legal o centro educativo especialmente autorizado para ello. Cuando un usuario se registra directamente en los SERVICIOS VICENS VIVES reconoce expresamente ser mayor de 16 años y se hace responsable de dicha declaración.'
        )}
      </p>
      <p>
        {t(
          'En caso de duda razonable sobre la edad de un usuario, VICENS VIVES tiene el derecho de suspender o bloquear la cuenta de usuario hasta que el usuario pruebe fehacientemente que tiene 16 años o más. Para ello, VICENS VIVES se pondrá en contacto con el usuario para que le proporcione fotocopia del DNI, NIE, Pasaporte o documento equivalente. Si no se proporciona la información en la forma y plazo requeridos por VICENS VIVES, la cuenta de usuario podrá ser eliminada. La fotocopia recibida solo será utilizada para comprobar la edad del usuario y no con otra finalidad.'
        )}
      </p>
      <p>
        {t(
          'Recomendamos a los usuarios de entre 16 y 18 años que consulten e informen a sus padres y tutores legales antes de proceder a registrarse en los SERVICIOS VICENS VIVES.'
        )}
      </p>
      <p>
        {t('8.1.- A continuación, se expone la forma de lleva a cabo el')}{' '}
        <b>{t('Registro de usuarios menores de 16 años')}:</b>
      </p>
      <p>
        {t(
          'Solamente los padres, madres y tutores legales o centros educativos autorizados a tal efecto (en adelante “familiar” o “familiares”) de un menor de 16 años tendrán la posibilidad de registrar a un usuario que no llegue a la edad mínima requerida (16 años). VICENS VIVES facilita este registro, preservando la intimidad de los menores y de los propios familiares.'
        )}
      </p>
      <p>
        {t(
          'Cuando un usuario menor de 16 años quiere formar parte de los SERVICIOS VICENS VIVES ya sea por voluntad propia, porque lo han requerido en su centro educativo o porque sus familiares así lo han decidido, el sistema solicitará a un familiar del menor que realice el proceso de registro en nombre y representación del menor.'
        )}
      </p>
      <p>
        {t(
          'Llegados a este punto, el familiar asume completamente la responsabilidad acerca del registro que llevará a cabo, eximiendo a VICENS VIVES completamente de las responsabilidades y asumiendo exclusivamente las consecuencias y daños y perjuicios que puedan acaecer. Por lo tanto, VICENS VIVES no se hace responsable en ningún caso de un registro fraudulento llevado a cabo por un usuario.'
        )}
      </p>
      <p>
        {t(
          'El primer paso para poder registrar a un usuario menor de 16 años consiste en el registro del familiar que lo dará de alta en VICENS VIVES (con el perfil “familiar”). Una vez realizado este paso, los familiares podrán añadir menores de 16 años asociados a su perfil de usuario.'
        )}
      </p>
      <p>
        {t(
          'Una vez registrado el familiar, el usuario deberá proporcionar la siguiente información para proceder a registrar un usuario menor de 16 años'
        )}
        :
      </p>
      <ul>
        <li>
          {t('Información del familiar')}:
          <ul>
            <li>
              {t(
                'Número de DNI/NIE/Pasaporte o documento equivalente (esta información se solicita para garantizar que no hay suplantación de identidad y para preservar la intimidad y seguridad de los usuarios menores de 16 años. Este número no será, en ningún caso, visible al resto de usuarios de VICENS VIVES ni proporcionado a terceras personas).'
              )}
            </li>
            <li>{t('Teléfono')}</li>
            <li>{t('Código postal')}</li>
            <li>{t('Correo electrónico')}</li>
            <li>{t('Contraseña')}</li>
          </ul>
        </li>
        <li>
          {t('Información del usuario menor de 16 años')}:
          <ul>
            <li>{t('Nombre')}</li>
            <li>{t('Apellidos')}</li>
            <li>{t('Nombre de usuario')}</li>
            <li>{t('Contraseña')}</li>
          </ul>
        </li>
      </ul>
      <p>
        {t(
          'La validación de todos los usuarios involucrados en el proceso se hará haciendo clic en la URL del correo electrónico de validación que recibirá el familiar.'
        )}
      </p>
      <p>
        {t(
          'En cualquier momento los familiares podrán añadir/vincular a más usuarios menores de 16 años y desvincular/eliminar usuarios menores de 16 años. Un usuario menor de 16 años no puede estar desvinculado de un familiar.'
        )}
      </p>
      <p>
        {t(
          'En caso de duda razonable sobre la identidad de un usuario (del familiar o del usuario menor de 16 años), VICENS VIVES tiene el derecho de suspender o bloquear la cuenta o las cuentas de usuario hasta que el usuario pruebe fehacientemente su identidad y la relación parental o de representación legal con el menor registrado. Para ello, VICENS VIVES se pondrá en contacto con el familiar para que le proporcione fotocopia o fotografía del DNI, NIE, Pasaporte o documento equivalente y fotocopia del libro de familia o similar (si fuere necesario). Si no se proporciona la información en la forma y plazo requeridos por VICENS VIVES, la cuenta de usuario (y la de los usuarios menores de 16 años vinculados) podrá ser eliminada. La fotocopia recibida solo será utilizada para comprobar la información del usuario y no para otra finalidad.'
        )}
      </p>
      <p>
        {t(
          'Los perfiles de usuarios menores de 16 años de los SERVICIOS VICENS VIVES son tratados con el máximo de garantías para proteger y salvaguardar la intimidad, privacidad y seguridad de los mismos.'
        )}
      </p>
      <h3>{t('9. Descarga de la aplicación para dispositivos móviles')}</h3>
      <p>
        {t(
          'La aplicación Edubook para dispositivos móviles compatibles puede obtenerse únicamente a través de las plataformas autorizadas por VICENS VIVES iTunes para sistemas operativos iOS y Google Play para sistemas operativos Android.'
        )}
      </p>
      <p>
        {t(
          'VICENS VIVES no se hace responsable del mantenimiento ni buen funcionamiento de las aplicaciones adquiridas fuera de las plataformas indicadas anteriormente.'
        )}
      </p>
      <h3>{t('10. Suplantación de perfiles')}</h3>
      <p>
        {t(
          'Las suplantaciones de perfiles están expresamente prohibidas en los SERVICIOS VICENS VIVES. español. Cualquier indicio de suplantación de perfil supondrá el inicio del proceso de comprobación de la identidad del usuario y el bloqueo de su cuenta de usuario.'
        )}
      </p>
      <p>
        {t(
          'En caso de que no se pueda comprobar la correcta identidad de un usuario o se demuestre que ha habido una suplantación de un perfil, se procederá a la cancelación definitiva de la cuenta de usuario. VICENS VIVES se reserva el derecho a informar a las autoridades policiales y judiciales competentes acerca de la suplantación de perfil realizada.'
        )}
      </p>
      <p>
        {t(
          'Recomendamos a todos los usuarios que se pongan en contacto con VICENS VIVES si conocen, o tienen indicios, de que un perfil de usuario ha sido víctima de una suplantación de identidad.'
        )}
      </p>
      <h3>{t('11. Seguridad del perfil')}</h3>
      <p>
        {t(
          'VICENS VIVES garantiza la seguridad y privacidad de los datos de perfil de los usuarios.'
        )}
      </p>
      <p>
        {t(
          'Para garantizar la seguridad de los datos de usuario, este se obliga a usar los SERVICIOS VICENS VIVES de forma estrictamente personal, recomendándose a tal efecto la no comunicación de sus datos a terceros.'
        )}
      </p>
      <p>
        {t(
          'Asimismo, los usuarios se obligan a no proporcionar datos falsos a VICENS VIVES ni suplantar identidad alguna. El incumplimiento de este extremo podrá suponer el bloqueo y/o cancelación de la cuenta de usuario de los SERVICIOS VICENS VIVES.'
        )}
      </p>
      <h3>{t('12. Baja de los Servicios VICENS VIVES')}</h3>
      <p>
        {t(
          'Los usuarios podrán darse de baja de los SERVICIOS VICENS VIVES en cualquier momento escribiendo un correo electrónico a'
        )}{' '}
        <a href='mailto:legal@vicensvives.com'>{t('legal@vicensvives.com')}</a>.
      </p>
      <p>
        {t(
          'Cuando un usuario se dé de baja en el sistema, sus datos serán cancelados y conservados en los sistemas de información de VICENS VIVES de acuerdo con lo detallado en el apartado 6 anterior.'
        )}
      </p>
      <p>
        {t(
          'Una vez el usuario dé de baja su cuenta, no podrá recuperarla. Así pues, si el usuario quiere volver a darse de alta en VICENS VIVES tendrá que iniciar el proceso de registro de nuevo.'
        )}
      </p>
      <p>
        {t(
          'En todo caso, VICENS VIVES podrá cancelar aquellas cuentas de usuarios en las que no consten licencias activas durante 12 meses seguidos. Si el usuario quiere volver a darse de alta en VICENS VIVES tendrá que iniciar el proceso de registro de nuevo.'
        )}
      </p>
      <p>
        {t(
          'VICENS VIVES le asegura la confidencialidad de sus datos personales y le garantiza la seguridad de los mismos, adoptando las medidas necesarias para evitar su alteración, pérdida, tratamiento o acceso no autorizado.'
        )}
      </p>
      <p>
        {t(
          'La entrega de datos personales es absolutamente voluntaria para el Usuario, si bien la carencia de facilitar determinados datos o preguntas que pudieran formularse en los procesos de registro o en los distintos formularios electrónicos que se le presenten al Usuario, puede provocar la imposibilidad de acceso a determinados servicios para cuya prestación se han solicitado los datos de carácter personal, en tal caso VICENS VIVES informará del carácter obligatorio y/o necesario de facilitar los datos personales para el funcionamiento del servicio.'
        )}
      </p>
    </div>
  )
}
export default PoliticaPrivacidad
